import React, {useCallback, useEffect, useState} from 'react';
import {Box, Card, Typography} from '@mui/material';
import InstituteCard from '@jobseeker/lotus/components/InstituteCard';
import type {} from '@jobseeker/lotus/mui.types';
import {InstituteCardDataType} from './types';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';
import type {AppState} from '@jobseeker/common-core/types';
import {useSelector} from 'react-redux';

const EligibilitySection = () => {
  const theme = useWrappedTheme();

  const {
    timelines: {
      ads,
      config: {eligibility},
    },
  } = useSelector((state: AppState) => state.competition);

  const institutes1Slot = ads?.eligibleCollege1?.slotId ?? '';
  const institutes2Slot = ads?.eligibleCollege2?.slotId ?? '';

  const [institutes1, setInstitutes1] = useState<InstituteCardDataType[]>([]);
  const [institutes2, setInstitutes2] = useState<InstituteCardDataType[]>([]);

  useLoadAds(institutes1Slot, setInstitutes1, {}, false);
  useLoadAds(institutes2Slot, setInstitutes2, {}, false);

  const [imagesLoaded, setImagesLoaded] = useState(false);
  const handleImageLoad = useCallback(() => {
    setImagesLoaded(true);
  }, []);

  useEffect(() => {
    if (institutes1.length > 0) {
      setImagesLoaded(true);
    }
  }, [institutes1]);
  const styles = {
    instituteListContainer: {
      margin: '0 auto 0 39px',
      display: 'flex',
      overflowX: 'hidden',
      width: 'fit-content',
      gap: '10px',
      justifyContent: 'flex-start',
      animation: imagesLoaded ? '45s linear infinite scrollalong' : 'none',
      '@keyframes scrollalong': {
        from: {
          transform: 'translateX(0)',
        },
        to: {
          transform: 'translateX(-50%)',
        },
      },
    },

    opportunityContainer: {
      display: 'block',
      width: 'fit-content',
      maxWidth: '100%',
      margin: '0 auto',
      backgroundColor: '#49966e',
      textAlign: 'center',
      color: '#fff',
      fontSize: {
        xs: theme.typography.pxToRem(14),
        md: theme.typography.pxToRem(18),
      },
      fontWeight: 300,
      marginBottom: 3,
      flexWrap: 'wrap',
      padding: 1,
    },
  };
  return (
    <Box id="eligibility" sx={{marginBottom: 4}}>
      <Card
        sx={{
          width: '100%',
          margin: '0 auto',
          padding: {xs: 3},
          paddingBottom: {xs: 3, md: 6},
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            margin: '0 auto',
            marginTop: {xs: 0, md: 3},
            marginBottom: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="sectionMainHeading"
            sx={{
              // marginTop: {xs: 3, md: 6},
              marginBottom: 0.5,
              fontSize: {
                md: theme.typography.pxToRem(42),
                xs: theme.typography.pxToRem(22),
              },
            }}
          >
            Eligibility
          </Typography>
        </Box>
        <Box sx={styles.opportunityContainer}>{eligibility?.label}</Box>
        {eligibility?.groups && eligibility?.groups[0] && (
          <>
            <Box sx={{textAlign: 'center'}}>
              <Typography
                sx={{
                  fontSize: {
                    xs: theme.typography.pxToRem(16),
                    md: theme.typography.pxToRem(18),
                  },
                  fontWeight: 600,
                  lineHeight: 1.22,
                  color: 'secondary.main',
                  marginBottom: 2.5,
                }}
              >
                {eligibility?.groups[0]?.label}
              </Typography>
            </Box>
            <Box
              sx={{
                position: 'relative',
                // overflow: 'hidden',
              }}
            >
              {' '}
              <Box sx={styles.instituteListContainer}>
                {[...institutes1, ...institutes1].map(
                  (institute1: InstituteCardDataType, index: number) => (
                    <InstituteCard
                      key={index}
                      instituteLogo={institute1.companyLogo}
                      instituteName={institute1.title}
                      onImageLoad={handleImageLoad}
                    />
                  )
                )}
              </Box>
            </Box>
          </>
        )}

        {eligibility?.groups && eligibility?.groups[1] && (
          <>
            <Box sx={{marginTop: 9, textAlign: 'center'}}>
              <Typography
                sx={{
                  fontSize: {
                    xs: theme.typography.pxToRem(16),
                    md: theme.typography.pxToRem(18),
                  },
                  fontWeight: 600,
                  lineHeight: 1.22,
                  color: 'secondary.main',
                  marginBottom: 2.5,
                }}
              >
                {eligibility?.groups[1]?.label}
              </Typography>
            </Box>

            <Box
              sx={{
                position: 'relative',
                // overflow: 'hidden',
              }}
            >
              <Box sx={styles.instituteListContainer}>
                {[...institutes2, ...institutes2].map(
                  (institute2: InstituteCardDataType, index: number) => (
                    <InstituteCard
                      key={index}
                      instituteLogo={institute2.companyLogo}
                      instituteName={institute2.title}
                      onImageLoad={handleImageLoad}
                    />
                  )
                )}
              </Box>
            </Box>
          </>
        )}
      </Card>
    </Box>
  );
};

export default EligibilitySection;
